<template>
  <el-dialog
    title="发票详情"
    :visible.sync="dialogFormVisible"
    width="1000px"
    @close="closeDialog"
  >
    <el-tabs v-model="activeTab" type="border-card">
      <el-tab-pane label="发票信息" name="invoiceInfo">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="发票号码">
            {{ invoiceInfo.invoiceNumber || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="特定要素标识">
            {{ specialInvoiceTypeMap[invoiceInfo.specialInvoiceType] || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="发票种类">
            {{ invoiceLineEnum[invoiceInfo.invoiceLine] || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="发票类型">
            <el-tag :type="invoiceTypeMap[invoiceInfo.invoiceType]?.type">
              {{ invoiceTypeMap[invoiceInfo.invoiceType]?.label || "-" }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="开票人">
            {{ invoiceInfo.clerk || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="含税金额">
            {{ invoiceInfo.taxAmountTotal || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="未税金额">
            {{ invoiceInfo.taxFreeAmountTotal || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="税额">
            {{ invoiceInfo.taxTotal || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="备注">
            {{ invoiceInfo.remark || "-" }}
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>

      <el-tab-pane label="购销方信息" name="buyerSellerInfo">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="购方名称">
            {{ buyerSellerInfo.buyerName || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="购方税号">
            {{ buyerSellerInfo.buyerTaxnum || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="购方开户行及账号">
            {{ buyerSellerInfo.buyerBankAccount || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="购方地址电话">
            {{ buyerSellerInfo.buyerAddressTel || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="销方名称">
            {{ buyerSellerInfo.sellerName || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="销方税号">
            {{ buyerSellerInfo.sellerTaxnum || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="销方开户行及账号">
            {{ buyerSellerInfo.sellerBankAccount || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="销方地址电话">
            {{ buyerSellerInfo.sellerAddressTel || "-" }}
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>

      <el-tab-pane label="其他信息" name="otherInfo">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="PDF">
            {{ otherInfo.pdfUrl || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="OFD">
            {{ otherInfo.ofdUrl || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="XML">
            {{ otherInfo.xmlUrl || "-" }}
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>

      <el-tab-pane label="发票明细" name="invoiceDetail">
        <el-table
          ref="detailTableRef"
          v-loading="detailLoading"
          border
          :data="detailList"
          size="mini"
          max-height="400"
        >
          <el-table-column
            align="center"
            width="50"
            type="index"
            label="序号"
          />
          <el-table-column
            prop="goodsShortName"
            label="简称"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="goodsName"
            label="商品名称"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="specType"
            label="规格型号"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="goodsUnit"
            label="单位"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="goodsPrice"
            label="单价"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="goodsNum"
            label="数量"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="taxAmount"
            label="含税金额"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="taxFreeAmount"
            label="不含税金额"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="tax"
            label="税额"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="taxRate"
            label="税率"
            align="center"
            show-overflow-tooltip
          />
        </el-table>
        <el-pagination
          background
          :current-page="queryForm.pageNo"
          :page-size="queryForm.pageSize"
          :layout="layout"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
export default {
  name: "InvoiceDetail",
  data() {
    return {
      activeTab: "invoiceInfo",
      dialogFormVisible: false,
      detailLoading: false,
      layout: "total, sizes, prev, pager, next, jumper",
      total: 0,
      invoiceInfo: {},
      buyerSellerInfo: {},
      otherInfo: {},
      detailList: [],
      invoiceTypeMap: {
        1: { label: "蓝票", type: "" },
        2: { label: "红票", type: "danger" },
      },
      queryForm: {
        pageNo: 1,
        pageSize: 20,
        invoiceCode: "",
        invoiceNumber: "",
      },
      specialInvoiceTypeMap: {
        "01": "成品油",
        "02": "稀土",
        "03": "机动车",
        "04": "货物运输",
        "05": "不动产销售",
        "06": "不动产租赁",
        "07": "代收车船使用税",
        "08": "通行费",
        "09": "旅客运输",
        10: "医疗服务（住院）",
        11: "医疗服务（门诊）",
        12: "自产农产品发票",
        13: "通行费",
        15: "二手车",
        16: "农产品",
        17: "光伏收购",
        18: "卷烟",
        19: "出口发票",
        31: "建安发票",
        32: "房地产销售发票",
        103: "建筑服务发票",
      },
      invoiceLineEnum: {
        p: "普通发票（电票）",
        c: "普通发票（纸质）",
        s: "专用发票（纸质）",
        b: "专用发票（电子）",
        bs: "数电专票（电子）",
        pc: "数电普票（电子）",
        es: "数电专票（纸质）",
        ec: "数电普票（纸质）",
      },
    };
  },
  methods: {
    showDetailDialog(row) {
      console.log("打开发票详情对话框", row);
      this.activeTab = "invoiceInfo";
      this.invoiceInfo = { ...row };
      this.buyerSellerInfo = { ...row };
      this.otherInfo = { ...row };
      this.queryForm.invoiceCode = row.invoiceCode;
      this.queryForm.invoiceNumber = row.invoiceNumber;
      this.fetchInvoiceDetail(row);
      this.dialogFormVisible = true;
    },

    fetchInvoiceDetail() {
      this.detailLoading = true;
      const { userId } = this.$route.query;
      this.$api
        .post("/input/income-pool-invoice-detail-new/queryDetailList", {
          userId: userId,
          ...this.queryForm,
        })
        .then((res) => {
          console.log("发票明细数据", res);
          this.detailList = res.data.records || [];
          this.total = res.data.total || 0;
          this.detailLoading = false;
        })
        .catch((err) => {
          console.log("err", err);
          this.$message.error(err.message);
          this.detailLoading = false;
        });
    },

    /**
     * @description 改变列表每页显示条数
     */
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchInvoiceDetail();
    },

    /**
     * @description 改变列表页数
     */
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.fetchInvoiceDetail();
    },

    closeDialog() {
      this.invoiceInfo = {};
      this.buyerSellerInfo = {};
      this.otherInfo = {};
      this.detailList = [];
      this.total = 0;
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = 20;
      this.queryForm.invoiceCode = "";
      this.queryForm.invoiceNumber = "";
      this.activeTab = "invoiceInfo";
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs--border-card {
  box-shadow: none;
}

::v-deep .el-descriptions-item__label {
  width: 140px;
  background-color: #f5f7fa;
}

::v-deep .el-descriptions-item__content {
  min-width: 200px;
}
</style>
